import { gql } from '@apollo/client/core';

export {
  BankByBikDocument,
  type BankByBikQuery,
  LegalEntityStatus,
  type LegalEntitySuggestionsQuery,
  LegalForm,
  useLegalEntitySuggestionsQuery,
} from '@shared/api/graphql/generated';

export const LEGAL_ENTITY_SUGGESTIONS = gql`
  query LegalEntitySuggestions($query: String!, $locationId: ID) {
    legalEntitySuggestions(query: $query, locationId: $locationId) {
      name
      legal_form
      tin
      kpp
      ogrn
      address
      status
      liquidated_on
    }
  }
`;

export const BANK_BY_BIK = gql`
  query BankByBik($bik: String!) {
    bankByBik(bik: $bik) {
      name
      bik
      correspondent_account
    }
  }
`;
